// extracted by mini-css-extract-plugin
export var searchHeader = "_3y-0";
export var searchHeaderDark = "_3y-1";